import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { Spinner } from "reactstrap";

// redux
import { useSelector } from "react-redux";

//constants
import { layoutTypes } from "../components/constants/layout";

// layouts
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout/Index";
import HorizontalLayout from "../Layout/HorizontalLayout/Index";
import { AccessRoute } from "./AuthProtected";

import { authProtectedRoutes, publicRoutes } from "./allRoutes";

const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const Index = () => {
  const availablePublicRoutesPaths = publicRoutes.map((r) => r.path);
  const availableAuthRoutesPath = authProtectedRoutes.map((r) => r.path);

  const { layoutType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
  }));

  const Layout = getLayout(layoutType);

  return (
    <Switch>
      <Route path={availablePublicRoutesPaths}>
        <NonAuthLayout>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <Route
                path={route.path}
                component={route.component}
                key={idx}
                exact={true}
              />
            ))}
          </Switch>
        </NonAuthLayout>
      </Route>

      <Route path={availableAuthRoutesPath}>
        <Layout>
          <Suspense
            fallback={
              <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <Spinner color="primary" />
              </div>
            }
          >
            <Switch>
              {authProtectedRoutes.map((route, idx) => (
                <AccessRoute
                  path={route.path}
                  component={route.component}
                  // 路由自己宣告需要的權限與模組名(票 route-guard/01);
                  // 沒宣告 perm 的維持原行為(只擋未登入)
                  perm={route.perm}
                  key={idx}
                  exact={true}
                />
              ))}
            </Switch>
          </Suspense>
        </Layout>
      </Route>
    </Switch>
  );
};

export default Index;


